import React from 'react'

export default props => (
    <section className='content' style={{ padding: 8, height: props.height }}>
		{props.children}
	</section>
)
